"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PreKeyStore = (function () {
    function PreKeyStore() {
    }
    return PreKeyStore;
}());
exports.default = PreKeyStore;



//////////////////
// WEBPACK FOOTER
// ../proteus/dist/session/PreKeyStore.js
// module id = 111
// module chunks = 0 1